module.exports = __webpack_public_path__ + "img/ma.9b93c0ee.png";